import React from 'react';
import { useNavigate } from 'react-router-dom';
import AutoPilotWizard from '../components/AutoPilotWizard';

const AutoPilotPage = () => {
  const navigate = useNavigate();

  return (
    <div className="autopilot-page" style={{ position: 'relative' }}>
      <AutoPilotWizard
        onClose={() => navigate('/dashboard')}
        onSuccess={(message) => {
          console.log('Auto Pilot success:', message);
          navigate('/campaigns');
        }}
      />
    </div>
  );
};

export default AutoPilotPage;
